"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./Loader.scss");
var Loader_1 = require("wix-style-react/Loader");
var LoaderWrap = (function (_super) {
    __extends(LoaderWrap, _super);
    function LoaderWrap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderWrap.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cc-spinner", className: this.props.size === 'medium' ? s.loaderWrap : s.small },
            React.createElement(Loader_1.default, { size: this.props.size })));
    };
    LoaderWrap.defaultProps = {
        size: 'medium',
    };
    return LoaderWrap;
}(React.Component));
exports.default = LoaderWrap;
//# sourceMappingURL=Loader.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Loader/Loader.js
// module id = 155
// module chunks = 0 1